// src/lib/loginZiel.ts
// Paket 36 (Dominik 22.10.2026): Login-Umleitung behält das Ziel (z. B. den Objekt-Link aus der
// Reaktivierungs-Mail /deal/:id?tab=annahmen&utm_…). Login.tsx liest ?next= und prüft es selbst
// (nur relative Pfade).
export function loginZiel(pfad: string, suche: string): string {
  const ziel = `${pfad}${suche ?? ""}`;
  if (!pfad.startsWith("/") || pfad === "/" || pfad.startsWith("/login")) return "/login";
  return `/login?next=${encodeURIComponent(ziel)}`;
}
